import {EventReducer, ReducerFromState} from "../../../@types/reducers";
import {AlertEventObject} from "../../../@types/response";

export const getMonitors = (state: ReducerFromState<EventReducer>): Array<AlertEventObject> => state.event.monitors;
